module.exports = __webpack_public_path__ + "img/star.0787cadf.png";